import {
  ApiResponse,
  Certification,
  DeepPartial,
  EducationEdit,
  ExperienceEdit,
  ExperienceEditResponse,
  HobbiesEdit,
  LanguagesEdit,
  PersonalData,
  SkillsEdit,
  UserSurveyAnswersResponse,
  UserSurveyQuestionsResponse,
} from "../types/profile-editing";
import axiosInstance from "../utils/axios";

export const fetchPersonalInfo = async () => {
  try {
    const response = await axiosInstance.get<ApiResponse<PersonalData>>(
      "/api/profiles/personal/"
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const updatePersonalInfo = async (
  credentials: DeepPartial<PersonalData>
) => {
  try {
    const response = await axiosInstance.patch<ApiResponse<PersonalData>>(
      "/api/profiles/personal/",
      credentials
    );

    // if (response.data.status !== "success") {
    //   throw new Error("Failed to update profile");
    // }

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

//========================Certifications================================

export const addCertification = async (
  credentials: DeepPartial<Certification>
) => {
  try {
    const response = await axiosInstance.post<ApiResponse<Certification>>(
      "/api/profiles/certificates/",
      credentials
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const updateCertification = async (
  credentials: DeepPartial<Certification>
) => {
  try {
    const response = await axiosInstance.patch<ApiResponse<Certification>>(
      `/api/profiles/certificates/${credentials.id}/`,
      credentials
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const deleteCertification = async (id: number) => {
  try {
    const response = await axiosInstance.delete(
      `/api/profiles/certificates/${id}/`
    );
    if (response.status === 204) return;
    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

//======================== Education ================================

export const addEducation = async (credentials: EducationEdit) => {
  try {
    const response = await axiosInstance.post<ApiResponse<EducationEdit>>(
      "/api/profiles/educations/",
      credentials
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const updateEducation = async (credentials: EducationEdit) => {
  try {
    const response = await axiosInstance.patch<ApiResponse<EducationEdit>>(
      `/api/profiles/educations/${credentials.id}/`,
      credentials
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const deleteEducation = async (id: number) => {
  try {
    const response = await axiosInstance.delete(
      `/api/profiles/educations/${id}/`
    );
    if (response.status === 204) return;
    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

//======================== Experience ================================

export const addExperience = async (credentials: ExperienceEdit) => {
  try {
    const response = await axiosInstance.post<ApiResponse<ExperienceEdit>>(
      "/api/profiles/experiences/",
      credentials
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const updateExperience = async (credentials: ExperienceEdit) => {
  try {
    const response = await axiosInstance.patch<ExperienceEditResponse>(
      `/api/profiles/experiences/${credentials.id}/`,
      credentials
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const deleteExperience = async (id: number) => {
  try {
    const response = await axiosInstance.delete(
      `/api/profiles/experiences/${id}/`
    );
    if (response.status === 204) return;
    return response.data;
  } catch (error) {
    console.error("Error updating experience:", error);
    throw new Error("Failed to update experience");
  }
};

//======================== Skills ================================

export const addSkills = async (credentials: SkillsEdit) => {
  try {
    const response = await axiosInstance.post<ApiResponse<SkillsEdit>>(
      "/api/profiles/skills/",
      credentials
    );

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const updateSkills = async (credentials: SkillsEdit) => {
  try {
    const response = await axiosInstance.patch<ApiResponse<SkillsEdit>>(
      `/api/profiles/skills/${credentials.id}/`,
      credentials
    );

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const deleteSkills = async (id: number) => {
  try {
    const response = await axiosInstance.delete(`/api/profiles/skills/${id}/`);
    if (response.status === 204) return;
    return response.data;
  } catch (error) {
    throw error;
  }
};

//===============================Languages========================================

export const addLanguage = async (credentials: LanguagesEdit) => {
  try {
    const response = await axiosInstance.post<ApiResponse<LanguagesEdit>>(
      "/api/profiles/languages/",
      credentials
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const editLanguage = async (credentials: LanguagesEdit) => {
  try {
    const response = await axiosInstance.patch<ApiResponse<LanguagesEdit>>(
      `/api/profiles/languages/${credentials.id}/`,
      credentials
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const deleteLanguage = async (id: number) => {
  try {
    const response = await axiosInstance.delete(
      `/api/profiles/languages/${id}/`
    );
    if (response.status === 204) return;
    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const fetchLanguages = async () => {
  try {
    const response = await axiosInstance.get<ApiResponse<LanguagesEdit[]>>(
      `/api/profiles/languages/`
    );

    return response.data.data;
  } catch (error) {
    console.error("Error updating language:", error);
    throw new Error("Failed to update language");
  }
};
//===============================Hobbies========================================

export const addHobbie = async (credentials: HobbiesEdit) => {
  try {
    const response = await axiosInstance.post<ApiResponse<HobbiesEdit>>(
      "/api/profiles/hobbies/",
      credentials
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const editHobbie = async (credentials: HobbiesEdit) => {
  try {
    const response = await axiosInstance.patch<ApiResponse<HobbiesEdit>>(
      `/api/profiles/hobbies/${credentials.id}/`,
      credentials
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const deleteHobbie = async (id: number) => {
  try {
    const response = await axiosInstance.delete(`/api/profiles/hobbies/${id}/`);
    if (response.status === 204) return;
    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const fetchHobbie = async () => {
  try {
    const response = await axiosInstance.get<ApiResponse<HobbiesEdit[]>>(
      `/api/profiles/hobbies/`
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

//===============================Survey Questions========================================

export const fetchSurveyQuestions = async (language: string = "en") => {
  try {
    const response = await axiosInstance.get<UserSurveyQuestionsResponse>(
      `/api/profiles/survey-questions/?lang=${language}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetch questions:", error);
    throw new Error("Failed to fetch questions");
  }
};

export const fetchSurveyAnswers = async (language: string = "en") => {
  try {
    const response = await axiosInstance.get<UserSurveyAnswersResponse>(
      `/api/profiles/survey-answers/?lang=${language}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching answers:", error);
    throw new Error("Failed to fetch answers");
  }
};

export const sendSurveyAnswers = async (answers: {
  [key: string]: { answer_ids: number[]; text_answer?: string };
}) => {
  try {
    const response = await axiosInstance.put<UserSurveyAnswersResponse>(
      `/api/profiles/survey-answers/`,
      {
        answers,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error sending answers:", error);
    throw new Error("Failed to send answers");
  }
};

//===============================Profile Tooltip Display========================================

export const editTooltipDisplay = async (credential: boolean) => {
  try {
    const response = await axiosInstance.patch(
      `/api/profiles/display-preferences/`,
      { hide_profile_completeness_tooltip: credential }
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const tourButtonDisplay = async (credential: boolean) => {
  try {
    const response = await axiosInstance.patch(
      `/api/profiles/display-preferences/`,
      { hide_tour_tooltip_report: credential }
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const tourDisplay = async (credential: { [key: string]: boolean }) => {
  try {
    const response = await axiosInstance.patch(
      `/api/profiles/display-preferences/`,
      credential
    );

    return response.data.data;
  } catch (error: any) {
    throw error.response.data;
  }
};
